import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import { handleResponseCode } from "../../../../app/utilities/helpers";
import GetProxy from "../../../../app/GetProxy";
const cookies = new Cookies();
const proxy = GetProxy();

export const gettoolsList = createAsyncThunk(
  "post/gettoolsList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/tools/list/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const testToolConnection = createAsyncThunk(
  "post/testToolConnection",
  async (payload) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/tools/testConnection`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getJirasave = createAsyncThunk(
  "post/getJirasave",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/IssueType/save/issueTypesAndFields`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const deleteJiracategory = createAsyncThunk(
  "Delete/deleteJiracategory",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/IssueType/deleteUserField`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getConfigJiraList = createAsyncThunk(
    "get/getConfigJiraList",
    async (props) => {
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        // const { id } = props;
        const res = await fetch(
          `${proxy}/IssueType/getCombinedData`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "DTOP-API-TOKEN": Apitoken,
                    USERNAME: User,
                },
            }
        ).then((resp) => resp.json());
        handleResponseCode(res);
        return res;
    }
);


const ToolSlice = createSlice({
  name: "ToolSlice",
  initialState: {
    resetData: [],
    getToolsListData: [],
    toolsCountData: [],
    toolsidDta: [],
    toolsLoading: false,
    toolscountLoading: false,
    error: [],
    jiradata:[],
    jiraLoading:false,
    jiraDeletedata:[],
    jiraDeleteLoading:false,
    CatagorizedData:[],
    ConfigJiraListLoading:false,
  },
  reducers: {
    setTools: {
      reducer(state, action) {
        state.resetData = action.payload;
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(gettoolsList.pending, (state, action) => {
        state.toolsLoading = true;
      })
      .addCase(gettoolsList.fulfilled, (state, action) => {
        state.getToolsListData = action.payload.data;
        state.toolsCountData = action.payload.totalCount;
        state.toolsLoading = false;
      })
      .addCase(gettoolsList.rejected, (state, action) => {
        state.toolsLoading = false;
        state.getToolsListData = [];
        state.error = "Something went wrong";
      })


      .addCase(getJirasave.pending, (state, action) => {
        state.jiraLoading = true;
      })
      .addCase(getJirasave.fulfilled, (state, action) => {
        state.jiradata = action.payload;
        state.jiraLoading = false;
      })
      .addCase(getJirasave.rejected, (state, action) => {
        state.jiraLoading = false;
        state.jiradata = [];
        state.error = "Something went wrong";
      })
      //delete
      .addCase(deleteJiracategory.pending, (state, action) => {
        state.jiraDeleteLoading = true;
      })
      .addCase(deleteJiracategory.fulfilled, (state, action) => {
        state.jiraDeletedata = action.payload;
        state.jiraDeleteLoading = false;
      })
      .addCase(deleteJiracategory.rejected, (state, action) => {
        state.jiraDeleteLoading = false;
        state.jiraDeletedata = [];
        state.error = "Something went wrong";
      })

      .addCase(getConfigJiraList.pending, (state, action) => {
        state.ConfigJiraListLoading = true;
      })
      .addCase(getConfigJiraList.fulfilled, (state, action) => {
        state.CatagorizedData = action.payload;
        state.ConfigJiraListLoading = false;
      })
      .addCase(getConfigJiraList.rejected, (state, action) => {
        state.ConfigJiraListLoading = false;
        state.CatagorizedData = [];
        state.error = "Something went wrong";
      })


;
  },
});

export const { setTools } = ToolSlice.actions;

export default ToolSlice.reducer;
